import { Tooltip as MuiTooltip } from "@mui/material";

import { Box } from "ui/box/box";
import { mergeSx } from "ui/merge-sx";
import {
  getTooltipSizeSx,
  TOOLTIP_VARIANT_SX,
  TOOLTIP_WRAPPER_SX,
} from "ui/tooltip/tooltip.styles";
import { DEFAULT_OFFSET_PX } from "ui/tooltip/tooltip.constants";
import { type TooltipProps } from "ui/tooltip/tooltip.types";
import { useTooltip } from "ui/tooltip/use-tooltip";

export const Tooltip = ({
  children,
  label,
  placement = "top",
  offset = DEFAULT_OFFSET_PX,
  disabled,
  suppressed = false,
  arrow = true,
  variant = "dark",
  width,
  maxWidth,
  wrapperSx,
  sx,
  ...rest
}: TooltipProps) => {
  const { isInert, title, popperModifiers, popperOptions } = useTooltip({ label, disabled, suppressed, offset });

  if (isInert) {
    return <>{children}</>;
  }

  return (
    <MuiTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      slotProps={{
        tooltip: { sx: mergeSx(TOOLTIP_VARIANT_SX[variant], getTooltipSizeSx(width, maxWidth), sx) },
        popper: { modifiers: popperModifiers, popperOptions },
      }}>
      <Box sx={mergeSx(TOOLTIP_WRAPPER_SX, wrapperSx)} {...rest}>
        {children}
      </Box>
    </MuiTooltip>
  );
};
